module.exports = __webpack_public_path__ + "static/image7-64e29336ab55b396ff8d11a59b5d7881.png";